import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-automatic-distribution-progress-modal-new',
  templateUrl: './automatic-distribution-progress-modal.component.html',
  styleUrls: ['./automatic-distribution-progress-modal.component.scss'],
  standalone: false,
})
export class AutomaticDistributionProgressModalComponent implements OnInit, OnDestroy {
  remainingSeconds = 120;

  private timerId: ReturnType<typeof setInterval> | null = null;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.timerId = setInterval(() => {
      this.remainingSeconds -= 1;

      if (this.remainingSeconds <= 0) {
        this.remainingSeconds = 0;
        this.clearTimer();
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  private clearTimer(): void {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }
}
